import { cn } from "@/lib/utils";
import type { LegalDocumentSection } from "./types";

export const SectionContent = ({
  section,
}: {
  section: LegalDocumentSection;
}) => {
  return (
    <section id={section.id} className="scroll-mt-10 space-y-4">
      <h2
        data-section-heading={section.id}
        className={cn(
          "font-semibold text-[#1C1E21]",
          section.isSub ? "text-lg" : "text-xl",
        )}
      >
        {section.title}
      </h2>

      {section.content && section.content.length > 0 ? (
        <div className="space-y-4 text-[15px] leading-7 text-[#464C53]">
          {section.content.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      ) : null}

      {section.subsections && section.subsections.length > 0 ? (
        <div className="mt-6 space-y-8 pl-0 md:pl-4 border-l-0 md:border-l border-transparent md:border-[#EDEEEE]/50">
          {section.subsections.map((sub) => (
            <SectionContent key={sub.id} section={sub} />
          ))}
        </div>
      ) : null}
    </section>
  );
};
